import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';
import type { ToasterProps } from 'sonner';

/**
 * Backoffice toast surface — bottom-right, 5s auto-dismiss, Korean dense tone.
 * Defaults can be overridden per call (e.g., `toast.success(msg, { duration })`).
 */
export const Toaster = ({
  richColors = true,
  position = 'bottom-right',
  duration = 5000,
  closeButton = true,
  ...props
}: ToasterProps) => (
  <SonnerToaster
    richColors={richColors}
    position={position}
    duration={duration}
    closeButton={closeButton}
    toastOptions={{
      style: {
        background: 'var(--surface-raised)',
        color: 'var(--content-strong)',
        borderColor: 'var(--divider-strong)',
        fontSize: 13,
      },
    }}
    {...props}
  />
);

export const toast = sonnerToast;
